import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="section page-top">
      <div className="container" style={{ textAlign: 'center' }}>
        <h1>Page not found</h1>
        <p className="muted">The page you are looking for does not exist.</p>
        <Link className="btn btn--primary" to="/">Back to Home</Link>
      </div>
    </section>
  );
}
